import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getMonitorList } from '@/service/Monitor';
// 获取监控数据
export var useMonitorList = function useMonitorList() {
  var loading = ref(true);
  var monitorData = ref({
    recordList: [],
    appKey: '',
    accessToken: ''
  });
  // 获取监控数据
  var getMonitorListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getMonitorList();
          case 4:
            data = _context.sent;
            monitorData.value = data;
            loading.value = false;
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            loading.value = false;
            console.log(_context.t0);
          case 13:
            _context.prev = 13;
            return _context.finish(13);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9, 13, 15]]);
    }));
    return function getMonitorListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [monitorData, loading, getMonitorListAsync];
};